import { IDropdownOption } from '@fluentui/react';
import FilterButton from '../../../common/views/FilterButton';
import { Utils } from '../../../common/views/Utils';
import { CustomerLevel } from '../../../customers/models/CustomerModel';
import { BooleanOption } from '../../../home/models/OtherTypes';
import { MenuFilterModel } from '../../models/CategoryModel';
import { ProductFilterModel, ProductFeatureType } from '../../models/ProductModel';

export type ProductFilterTextProps = {
    filter: ProductFilterModel;
    sizeOptions: IDropdownOption[];
    onChange: (newFilter: ProductFilterModel) => void;
}

export default function ProductFilterTextView({ filter, sizeOptions, onChange }: ProductFilterTextProps) {
    const printBooleanFilterText = (name: string, label: string) => {
        const anyFilter = filter as any;
        let value = anyFilter[name] as BooleanOption;

        return <>
            {value !== BooleanOption.none && <span>
                <FilterButton
                    text={label + ": " + BooleanOption[value]}
                    onDelete={() => onDeleteBooleanFilter(name)}
                />
            </span>}
        </>;
    }

    const onDeleteBooleanFilter = (name: string) => {
        const anyFilter = filter as any;
        anyFilter[name] = BooleanOption.none;
        onChange(anyFilter);
    }

    const onDeleteFeatureFilter = () => {
        filter.feature = ProductFeatureType.none;
        onChange(filter);
    }

    const onDeleteLevelFilter = () => {
        filter.level = CustomerLevel.none;
        onChange(filter);
    }

    const onSetNullFilter = (name: string) => {
        const anyFilter = filter as any;
        anyFilter[name] = undefined;
        onChange(anyFilter);
    }

    const onUncheckFilter = (name: string) => {
        const anyFilter = filter as any;
        anyFilter[name] = false;
        onChange(anyFilter);
    }

    const onDeleteCategoryFilterText = (currentItem: MenuFilterModel) => {
        filter.menuFilters = filter.menuFilters.filter(
            item => !(item.type === currentItem.type && item.value === currentItem.value)
        );

        onChange(filter);
    }

    const getSize = (sizeId: number) => {
        const option = sizeOptions.find((s: IDropdownOption) => s.key === sizeId);
        if (option) return option.text;

        return "";
    }

    return <>
        {filter.deletedOnly !== undefined && printBooleanFilterText("deletedOnly", "Deleted")}
        {filter.activeOnly !== undefined && printBooleanFilterText("activeOnly", "Active")}
        {filter.approvedOnly !== undefined && printBooleanFilterText("approvedOnly", "Approved")}
        {filter.inStock !== undefined && printBooleanFilterText("inStock", "InStock")}

        {filter.level !== CustomerLevel.none && <>
            <FilterButton
                text={"Level: " + CustomerLevel[filter.level]}
                onDelete={onDeleteLevelFilter}
            />
        </>}

        {filter.feature !== ProductFeatureType.none && <>
            <FilterButton
                text={"Feature: " + ProductFeatureType[filter.feature]}
                onDelete={onDeleteFeatureFilter}
            />
        </>}

        {!Utils.isNull(filter.sizeId) && <>
            <FilterButton
                text={"Size: " + getSize(filter.sizeId ?? 0)}
                onDelete={() => onSetNullFilter("sizeId")}
            />
        </>}

        {filter.noCategory && <>
            <FilterButton
                text={"No Category"}
                onDelete={() => onUncheckFilter("noCategory")}
            />
        </>}

        {filter.noEarningPoint && <>
            <FilterButton
                text={"No EarningPoint"}
                onDelete={() => onUncheckFilter("noEarningPoint")}
            />
        </>}

        {filter.menuFilters.map((item: MenuFilterModel, index: number) => {
            return <>
                <FilterButton
                    text={item.text}
                    onDelete={() => onDeleteCategoryFilterText(item)}
                />
            </>;
        })}
    </>;
}